import default1Src from "./assets/default-1.webp";
import default2Src from "./assets/default-2.webp";
import default3Src from "./assets/default-3.webp";
import default4Src from "./assets/default-4.webp";
import default5Src from "./assets/default-5.webp";
import default6Src from "./assets/default-6.webp";
import default7Src from "./assets/default-7.webp";
import default8Src from "./assets/default-8.webp";
import default9Src from "./assets/default-9.webp";

const DEFAULT_AGENT_IMAGES_DICT: Record<string, string> = {
  "default-1": default1Src,
  "default-2": default2Src,
  "default-3": default3Src,
  "default-4": default4Src,
  "default-5": default5Src,
  "default-6": default6Src,
  "default-7": default7Src,
  "default-8": default8Src,
  "default-9": default9Src,
};

export const getDefaultAgentImageSrc = (id: string): string => {
  const matchingImage =
    DEFAULT_AGENT_IMAGES_DICT[id as keyof typeof DEFAULT_AGENT_IMAGES_DICT];

  if (!matchingImage) {
    return DEFAULT_AGENT_IMAGES_DICT["default-1"];
  }

  return matchingImage;
};

export const defaultAgentImageList = Object.keys(
  DEFAULT_AGENT_IMAGES_DICT
).reduce<{ id: string; src: string }[]>((acc, key) => {
  acc.push({
    id: key,
    src: DEFAULT_AGENT_IMAGES_DICT[
      key as keyof typeof DEFAULT_AGENT_IMAGES_DICT
    ],
  });

  return acc;
}, []);
